export default __webpack_public_path__ + "static/logo-b3aa5de112f122d4df74ef3606db8d33.svg";